import { getIsNullish } from '../getIsNullish/getIsNullish';

export const isObject = (value: any): value is Record<PropertyKey, any> =>
  !getIsNullish(value) && typeof value === 'object' && !Array.isArray(value);
